import { Redirect, Route } from "react-router-dom";
import React from "react";
import { isUserLoggedIn } from "../redux/auth-slice";
import { oemValues } from "../constants/oem";
import { useSelector } from "react-redux";

export const PrivateRoute = ({
  component: Component,
  isVoiceRoute = false,
  ...rest
}) => {
  const isLoggedIn = useSelector(isUserLoggedIn);

  const canAccessRoute = isVoiceRoute
    ? isLoggedIn && oemValues.voiceControl
    : isLoggedIn;

  return (
    <Route
      {...rest}
      render={(props) =>
        canAccessRoute ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};
